import type { CategorySelectOption } from '../../common/types.tsx';
import type {
	JwmCategoryOptions,
	JwmCategoryOptions_jira_jwmCategoryOptions_JiraWorkManagementCategoryOptionConnection_edges as JwmCategoryOptionsEdges,
} from './__generated_apollo__/JwmCategoryOptions';

export const transformCategoryOptionsData = (data?: JwmCategoryOptions | null) => {
	if (
		data?.jira?.jwmCategoryOptions &&
		'edges' in data?.jira?.jwmCategoryOptions &&
		Array.isArray(data?.jira?.jwmCategoryOptions.edges)
	) {
		const items: CategorySelectOption[] = [];

		data.jira.jwmCategoryOptions.edges.forEach((edge: JwmCategoryOptionsEdges | null) => {
			if (edge && edge.node && edge.node.option) {
				items.push({
					label: edge.node.option.value ?? '',
					value: String(edge.node.option.optionId),
					color: edge.node.color,
				});
			}
		});

		return items;
	}

	return [];
};
